import { MerchandisingAlert } from "@apac/components/checkout";
import { useBooleanFlag } from "@apac/feature-flags";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { Product } from "@b2bportal/purchase-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FeatureFlagNames } from "@hsbc/utilities";
import { useSelectedPaymentInformation } from "./hooks";
import styles from "./styles.module.scss";

export const PaymentMethod = ({ product }: { product?: Product }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PaymentMethod");

  const { cardName, selectedPayment } = useSelectedPaymentInformation();
  const showMerchandising = useBooleanFlag(
    FeatureFlagNames.PERCENT_CASHBACK_OFFER_MERCHANDISING
  );

  return selectedPayment ? (
    <div className={block}>
      <div className={cn("container")}>
        <div className={cn("card-name")}>{t("paymentMethod")}</div>
        <div className={cn("card-value")}>
          <span>{cardName}</span>
          <span>{`**** ${selectedPayment.last4}`}</span>
        </div>
      </div>

      {showMerchandising && (
        <MerchandisingAlert
          selectedPayment={selectedPayment}
          product={product}
        />
      )}
    </div>
  ) : undefined;
};
